export const TAXES_CODES = {
    donation: 'txcd_90000001',
    asset: 'txcd_30021000',
};
